// Legacy redirect — the campus portal now uses /campus/cases. Any old
// link / bookmark pointing at /campus/competitions lands here briefly
// and bounces.
import { router, useFocusEffect } from "expo-router";
import { useCallback } from "react";
import { View } from "react-native";

export default function CampusCompetitionsRedirect() {
  useFocusEffect(
    useCallback(() => {
      router.replace("/campus/cases");
    }, []),
  );
  return <View />;
}
